module.exports = __webpack_public_path__ + "static/media/tile-play.52d61473.svg";